module.exports = __webpack_public_path__ + "static/media/compare_67.7b7af3b6.svg";